/* eslint-disable no-unused-vars */
import "./styles.css";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import MatchLogo from "assets/match-icon.svg";
import MatchInfoButton from "./sub/MatchInfoButton";
import MatchInfoText from "./sub/MatchInfoText";
import { MatchInfoButtonGroup } from "./sub/MatchInfoButtonGroup";

export default function MatchInfo({ event, activeTab, hideTabs }) {
  const navigation = useNavigate();
  const {
    id,
    title,
    courseName,
    teeName,
    rating,
    slope,
    numberOfTeeTimes,
    players,
    matchType,
    teamsPlay,
    bets,
  } = event;

  const numberOfPlayers = players?.length;

  const onPlayersClicked = () => {
    // TODO: navigate somewhere
  };

  const onTeeTimesClicked = () => {
    navigation(`/event/${id}/`, {
      replace: true,
    });
  };

  return (
    <div>
      <div className="match--info-container">
        {/* <div className="match--info-logo-container">
          <img
            className="match--info-logo-image"
            src={MatchLogo}
            alt="Match Logo"
          />
        </div> */}
        {/* <MatchInfoText
          title={title}
          courseName={courseName}
          teeName={teeName}
          rating={rating}
          slope={slope}
        /> */}
        {/* <MatchInfoButton
          value={numberOfPlayers}
          label="Players"
          onPress={onPlayersClicked}
        />
        <MatchInfoButton
          value={numberOfTeeTimes}
          label="Tee times"
          onPress={onTeeTimesClicked}
        /> */}
      </div>
      {!hideTabs && (
        <MatchInfoButtonGroup
          matchType={matchType}
          kickerBetMatchType={bets[0]?.matchType}
          activeTab={(object) => activeTab(object)}
          numberOfTeeTimes={numberOfTeeTimes}
          teamsPlay={teamsPlay}
        />
      )}
    </div>
  );
}

MatchInfo.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    courseName: PropTypes.string,
    teeName: PropTypes.string,
    rating: PropTypes.number,
    slope: PropTypes.number,
    numberOfTeeTimes: PropTypes.number,
    players: PropTypes.arrayOf(PropTypes.string),
    matchType: PropTypes.number,
    teamsPlay: PropTypes.bool,
    bets: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  }),
  activeTab: PropTypes.func.isRequired,
  hideTabs: PropTypes.bool,
};

MatchInfo.defaultProps = {
  event: {},
  hideTabs: false,
};
